import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const PoBills = lazy(() => import('../modules/po-bills'));

const PoBillsSection = lazy(
  () => import('../modules/po-bills/pages/PoBillsSection')
);
const PoBillsDetails = lazy(
  () => import('../modules/po-bills/pages/ViewPoBill')
);

// const CreatePoBill = lazy(
//   () => import('../modules/po-bills/pages/CreatePoBill')
// );
const EditPoBill = lazy(() => import('../modules/po-bills/pages/EditPoBill'));
const ClonePoBill = lazy(() => import('../modules/po-bills/pages/ClonePoBill'));

const PoBillsRoutes = (
  <>
    <Route
      path="purchases/po-bills"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <PoBills />
        </Suspense>
      }
    >
      {/* <Route
        path="new/create"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <CreatePoBill />
          </Suspense>
        }
      /> */}
      <Route
        path=":poBillId/edit"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <EditPoBill />
          </Suspense>
        }
      />
      <Route
        path=":poBillId/clone"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <ClonePoBill />
          </Suspense>
        }
      />
      <Route
        path=":poBillId/:action/:details?"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <PoBillsDetails />
          </Suspense>
        }
      />
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PO_BILLS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <PoBillsSection />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default PoBillsRoutes;
